/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import { useLocation } from 'react-router-dom';
import Switch from "react-switch";

import Colors from "constants/Colors";
import Icon from "components/Icon";
import HasPermission from 'components/HasPermission/index';
import { Row } from "components/Grid";

function ListEnquiryButtons(props) {
  const {showDeclineIcon, showRenewalsIcon} = props;
  const currentLocation = useLocation();

  const idOperationRoute = () => {
    if (props.listItem.renewalDomainStatus) {
      return props.listItem.idOperationRenewalQuote;
    }
    if (props.listItem.idDomain === 27) {
      return props.listItem.idOperationRoot;
    } else {
      return props.listItem.idOperation;
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flexDirection: 'column' }}>
      <Row className="align-items-center justify-content-start" style={{ width: props.widthAction ? props.widthAction : props.isPolicyScreen ? 80 : 65 }}>
        <HasPermission permission={!props.isAdmin}>
          <Icon
            name="edit"
            title="Editar Cotação"
            onClick={() => {
              // ref https://github.com/fitinsur/fitinsur-system/issues/17339
              //props.editRoute(idOperationRoute(), props.listItem.idProduct || props.listItem.productName === "GARANTIA SETOR PÚBLICO" ? 55 : 56)
              props.editRoute(idOperationRoute(), props?.listItem?.idProduct)
            }}
            style={props.listItem.isEdit ? icon : opacityAllowed} />
        </HasPermission>
          
        {(props.isPolicyScreen && props.permissions.CREATE_ENDORSEMENT) && (
          <Icon
            disabled={!props.listItem.canCreateEndorsement}
            name={"endorsementSelect"}
            title="Criar Endosso"
            onClick={() => props.newEndorsement(props.listItem.idOperation)}
            style={{ alignSelf: "center" }}
          />
        )}

        {showRenewalsIcon && (
          <Icon
            title="Renovar Apólice"
            name="renewals-gray"
            disabled={props.listItem?.renewalDomainStatus && props.listItem?.renewalDomainStatus !== 391}
            onClick={props.setShowModalConfirmation}
          />
        )}

        {showDeclineIcon && (
          <Icon
            title="Declinar"
            name="lost3"
            disabled={props.listItem?.renewalDomainStatus}
            onClick={props.setShowModalLost}
          />            
        )}
        
        {!props.isAdmin && (
          <Icon
            title="Gerenciar Documentos"
            name="folder"
            onClick={() => props.toDocument()} 
          />
        )}
        
        <HasPermission permission={props.permissions.CLONE_QUOTE && (currentLocation.pathname.includes('/list') || currentLocation.pathname.includes('/enquiries'))}>
          <Icon
            title="Clonar Cotação"
            name="copy"
            onClick={() => props.createCopy(props.listItem?.idProduct, props.listItem?.idOperation)}
          />
        </HasPermission>

        <HasPermission permission={props.isAdmin}>
          <Icon
            name="openEye"
            title="Visualizar"
            onClick={() => props.viewRoute()} 
           />
          <Icon
            name="edit"
            title="Editar Perfil de acesso"
            onClick={() => props.editRoute()} 
           />
          
          <Icon
            title="Clonar Perfil de Acesso"
            name="copy"
            onClick={() => props.setShowModalConfirmationClone()}
          />

          <Switch
            checked= { props.checkedExpireDate }
            onChange={() => props.setShowModalConfirmationExpire()}
            height={20}
            width={40}
            name="Excluir Perfil de Acesso"
            handleDiameter={15}
            checkedIcon={false}
            uncheckedIcon={false}
            offColor={Colors.GRAY[4]}
            onColor={Colors.GRAY[6] || Colors.GREEN}
            offHandleColor={props.checkedExpireDate ? Colors.DANGER : Colors.GRAY[6]}
            onHandleColor={Colors.WHITE}
          />
          
        </HasPermission>
        
      </Row>
    </div>
  )
}

const icon = {
  color: Colors.GRAY[6],
  marginRight: 5
};

const opacity = {
  color: Colors.GRAY[5],
  opacity: 0.5,
  cursor: "not-allowed",
  marginRight: 5
};

const opacityAllowed = {
  color: Colors.GRAY[5],
  opacity: 0.5,
  marginRight: 5
};

export default ListEnquiryButtons;